module.exports = __webpack_public_path__ + "img/kgjoner.e7371dde.jpg";